export default {
  tmp1: 'tmp1',
  tmp2: 'tmp2',
  tmp3: 'tmp3'
};


// WEBPACK FOOTER //
// ./src/app/containers/TourPage/components/Templates/consts.js